<template>
  <div class="driver-contact">
    <el-dialog
      :visible.sync="visible"
      fullscreen
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      custom-class="driver-contact-dialog"
      :show-close="true"
      @close="handleClose"
      title="合同管理"
    >
      <div class="header">
        <div>司机：{{ driver?.name }} 编号：{{ driver?.no }}</div>
        <div>
          <el-button type="primary" size="small" @click="handleAdd">新增合同</el-button>
        </div>
      </div>

      <div class="divider"></div>

      <div class="content">
        <driver-contract-item
          v-for="(item, idx) in contracts"
          :key="item.id || idx"
          :contract="item"
          :mode="item.editMode ? 'edit' : 'view'"
          :expanded="item.expanded"
          @edit="handleEdit(idx)"
          @save="(val) => handleSave(idx, val)"
          @cancel="handleCancelEdit(idx)"
          @delete="handleDelete(idx)"
          @toggleCollapse="handleToggleCollapse(idx)"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DriverContractItem from "./DriverContractItem.vue";
import { getDriverContractList } from "@/api";

export default {
  name: "DriverContact",

  components: { DriverContractItem },

  props: {},

  data() {
    return {
      contracts: [], // 合同列表
      mode: "view",
      visible: false,
      driver: null
    };
  },

  created() {},

  methods: {
    async getContractInfo() {
      getDriverContractList(this.driver.id).then((res) => {
        const list = res.data || [];
        this.contracts = list.map((item) => ({
          ...item,
          indicators: item.indicators || [],
          expanded: !!item.expanded,
          editMode: false
        }));
      });
    },

    handleAdd() {
      this.contracts.unshift({
        expanded: true,
        editMode: true,
        driverId: this.driver.id,
        signDate: null,
        deposit: 0,
        contractOn: null,
        contractOff: null,
        state: true,
        basePoints: 50,
        maxLeaveDaysPerMonth: 2,
        baseSalary: 5000,
        indicators: [],
        pdfOfFareCollection: null,
        pdfOfSafeDrive: null,
        pdfOfContact: null,
        pdfOfRiskNotification: null,
        pdfOfAdditionalAgreement: null,
        pdfOfLeaseContact: null,
        pdfOfLoanNote: null,
        pdfOfCommitmentOfPayment: null,
        pdfOfCommitmentOfQualifications: null,
        pdfOfRiskNotificationOfVehicle: null,
        pdfOfRiskNotificationOfContract: null
      });
    },

    handleEdit(idx) {
      this.$set(this.contracts, idx, { ...this.contracts[idx], editMode: true });
    },

    handleDelete(idx) {
      this.contracts.splice(idx, 1);
    },

    async handleSave(idx, val) {
      this.$set(this.contracts, idx, {
        ...val,
        indicators: val.indicators || [],
        editMode: false,
        expanded: this.contracts[idx].expanded
      });
    },

    handleCancelEdit(idx) {
      this.$set(this.contracts, idx, {
        ...this.contracts[idx],
        editMode: !this.contracts[idx].editMode
      });
    },

    handleToggleCollapse(idx) {
      this.$set(this.contracts, idx, {
        ...this.contracts[idx],
        expanded: !this.contracts[idx].expanded
      });
    },

    open(driver) {
      this.driver = driver;
      this.getContractInfo();
      this.visible = true;
    },

    handleClose() {
      this.visible = false;
      this.contracts = [];
      this.driver = null;
    }
  }
};
</script>

<style lang="less" scoped>
.driver-contact {
  padding: 20px;

  .mx-2 {
    margin: 0 8px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .divider {
    height: 1px;
    background-color: #e0e0e0;
    margin: 20px 0;
  }
}

::v-deep(.driver-contact-dialog .el-dialog__body) {
  padding: 20px;
}
</style>
